import script from "./baseProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./baseProduct.vue?vue&type=script&setup=true&lang=js"

import "./baseProduct.vue?vue&type=style&index=0&id=b07d6d72&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b07d6d72"]])

export default __exports__